import { PatientForm } from "@/dentlab/src/forms/form-components/patient/insert-update/patient.form";
import { PatientEntityType } from "@/lib/supabase/supabaseTypes";
import { PatientCoreForm } from "@/dentlab/src/forms/form-components/patient/insert-update/patient-core.form";
import { PatientExtendedForm } from "@/dentlab/src/forms/form-components/patient/insert-update/patient-extended.form";
import { Dialog, DialogContent, DialogTitle, VisuallyHidden } from "../../components/ui/dialog";

export const PatientFormDialog: React.FC<{
	open: boolean;
	onClose: () => void;
	patient?: PatientEntityType;
	onSave?: (patient: PatientEntityType) => void;
}> = ({ open, onClose, patient, onSave }) => {
	return (
		<>
			{patient ? (
				<Dialog
					open={open}
					onOpenChange={onClose}
				>
					<DialogContent className="sm:max-w-2xl max-h-[80vh] flex flex-col">
						<VisuallyHidden>
							<DialogTitle>Patient bearbeiten</DialogTitle>
						</VisuallyHidden>
						<PatientForm
							patientId={patient?.id as string}
							onSave={onSave}
							openExtended={true}
						>
							<div className="flex flex-col">
								<div className="text-lg pt-5">Neuer Patient</div>
								<PatientCoreForm />
							</div>
							<div className="flex flex-col pt-2">
								<div className="text-lg">Weitere Daten</div>
								<PatientExtendedForm />
							</div>
						</PatientForm>
					</DialogContent>
				</Dialog>
			) : (
				<Dialog
					open={open}
					onOpenChange={onClose}
				>
					<DialogContent className="sm:max-w-2xl max-h-[80vh] flex flex-col">
						<VisuallyHidden>
							<DialogTitle>Neuer Patient</DialogTitle>
						</VisuallyHidden>
						<PatientForm
							onSave={onSave}
							autosave={false}
							openExtended={true}
						>
							<div className="flex flex-col">
								<div className="text-lg pt-5">Neuer Patient</div>
								<PatientCoreForm />
							</div>
							<div className="flex flex-col pt-2">
								<div className="text-lg">Weitere Daten</div>
								<PatientExtendedForm />
							</div>
						</PatientForm>
					</DialogContent>
				</Dialog>
			)}
		</>
	);
};
